import React, { useEffect, forwardRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import PropTypes from 'prop-types';
import ProgressPopup from 'components/Common/Popup/ProgressPopup';
import { AccountIncorporationOfTermsSchema } from 'components/IncorporationOfTerms/IncorporationOfTermsSchema';
import FormTitle from 'components/IncorporationOfTerms/Register/FormAtoms/FormTitle';
import Form from 'components/IncorporationOfTerms/Register/FormMolecules/Form';
import AuthForm from 'components/IncorporationOfTerms/Register/FormMolecules/AuthForm';
import PasswordForm from 'components/IncorporationOfTerms/Register/FormMolecules/PasswordForm';
import NameForm from 'components/IncorporationOfTerms/Register/FormMolecules/NameForm';
import MobileForm from 'components/IncorporationOfTerms/Register/FormMolecules/MobileForm';
import ResidenceCntry from 'components/IncorporationOfTerms/Register/FormMolecules/ResidenceCntry';
import IdForm from 'components/IncorporationOfTerms/Register/FormMolecules/IdForm';
import EmailForm from 'components/IncorporationOfTerms/Register/FormMolecules/EmailForm';
import Terms from 'components/IncorporationOfTerms/Terms/Terms';
import { checkHasSameDomain } from 'utils/common';
import * as accountActions from 'redux/ducks/Employee/AccountDucks';
import * as alertActions from 'redux/ducks/common/alertDucks';
import * as popupActions from 'redux/ducks/common/popupDucks';

// [8.0] 01_britymail id등록

export const AccountRegister = ({ onValidationChange }, ref) => {
  const { employeeVo, isAuthSuccess, register } = useSelector(state => state.account);
  const { isPossible } = useSelector(state => state.employee);
  const isShowProgressPopup = useSelector(state => state.popup.ProgressPopup.isShow);
  // 최초 submit 없이 onChange 로 값 체크
  const dispatch = useDispatch();
  const { residenceCntry, termsContents } = useSelector(state => state.terms);

  const AccountFormMethods = useForm({
    mode: 'onChange',
    defaultValues: {
      authTarget: 'epOpenCode',
      userId: '',
      mphonNo: employeeVo.mphonNo,
      xtnlEmailAddr: employeeVo.xtnlEmailAddr,
    },
    resolver: yupResolver(AccountIncorporationOfTermsSchema()),
  });
  const {
    formState: { isValid },
  } = AccountFormMethods;

  useEffect(() => {
    onValidationChange(isValid);
  }, [isValid, onValidationChange]);

  useEffect(() => {
    if (!register) {
      dispatch(
        alertActions.open({
          isDimed: true,
          message: ['MB_M_DENY_PAGE'],
          callback: () => {
            window.close;
          },
        }),
      );
    }
  }, [register]);

  useEffect(() => {
    dispatch(accountActions.getNoSessionRegister());
    dispatch(accountActions.getNoSessionGlobalPosition());
  }, []);

  const accountOnSubmit = values => {
    // _2factorComp 회사면 if(mphonNo=='' && xtnlEmailAddr=='' ) 한번더 체크
    if (!isPossible && employeeVo.userId.indexOf('@') < 1) {
      dispatch(
        alertActions.open({
          message: ['MB_M_ID_RPTCHECK'],
        }),
      );
      return;
    }
    const pslInfoAgmts = [];
    termsContents.map(item => {
      pslInfoAgmts.push({
        trmsCd: item.trmsCd,
        trmsVerVal: item.trmsVerVal,
        agmtYn: 'Y',
      });
    });

    const _snm = employeeVo.snm ? employeeVo.snm : values.snm;
    const _gnm = employeeVo.gnm ? employeeVo.gnm : values.gnm;
    const _fnm = employeeVo.fnm ? employeeVo.fnm : values.fnm ? values.fnm : `${_snm}${_gnm}`;

    const payload = {
      ...employeeVo,
      optionValue: values.opt,
      xtnlEmailAddr: values.email,
      userId: employeeVo.userId.indexOf('@') > -1 ? employeeVo.userId : `${values.userId}${employeeVo.emailAddr}`,
      pwd: values.pwd,
      emailAddr: employeeVo.userId.indexOf('@') > -1 ? employeeVo.userId : `${values.userId}${employeeVo.emailAddr}`,
      confirmPwd: values.pwdConfirm,
      snm: _snm,
      mphonNo: values.mphonNo,
      gnm: _gnm,
      fnm: _fnm,
      emInofcStatsCd: 'B',
      jobplAddrCntryCd: residenceCntry.value,
      pslInfoAgmts,
    };
    if (employeeVo.serviceCdList?.indexOf('PT') !== -1 && checkHasSameDomain(payload.userId, payload.xtnlEmailAddr)) {
      dispatch(alertActions.open({ message: ['MB_M_DO_NOT_SAME_USERID_AND_MAIL_DOMAIN'] }));
      return;
    }
    dispatch(accountActions.updateEmployee(payload));
    dispatch(popupActions.openProgressPopup());
  };

  return (
    <>
      <Form formControl={AccountFormMethods} handleSubmit={accountOnSubmit} ref={ref}>
        <div className="form-section">
          <ul className="form-table">
            <AuthForm disabled={isAuthSuccess} />
            <FormTitle title="MB_T_INFORMATION" />
            <IdForm disabled={!isAuthSuccess} svcType={employeeVo.serviceCdList} />
            <PasswordForm disabled={!isAuthSuccess} />
            <NameForm disabled={!isAuthSuccess} snm={employeeVo.snm} gnm={employeeVo.gnm} fnm={employeeVo.fnm} />
            <EmailForm disabled={!isAuthSuccess} />
            <MobileForm disabled={!isAuthSuccess} />
            <ResidenceCntry />
          </ul>
          <Terms />
        </div>
      </Form>
      {isShowProgressPopup && <ProgressPopup />}
    </>
  );
};

AccountRegister.defaultProps = {
  onValidationChange: () => {},
};
AccountRegister.propTypes = {
  onValidationChange: PropTypes.func,
};

export default forwardRef(AccountRegister);
